import { createStyles } from '@material-ui/core';

export default () => createStyles({
  secondaryText: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#979797',
  },
});
